import React from "react";
import { AttributeFacet, BasicFacet, BasicFacetValue } from "../types/index";

interface SingleValueSliderProps {
  facet: BasicFacet;
  isExpanded: boolean;
  suffix?: string;
  onFilterChange: (value: number) => void;
  isFilterSelected: (
    facet: BasicFacet | AttributeFacet,
    value: BasicFacetValue
  ) => boolean;
}

export const SingleValueSlider: React.FC<SingleValueSliderProps> = ({
  facet,
  isExpanded,
  suffix = "",
  onFilterChange,
  isFilterSelected,
}) => {
  const getPriceLabel = (value: number, count: number): string => {
    return `${value}-${value + 500} (${count})`;
  };

  // Generate options for the checkboxes
  const generateOptions = () => {
    const options = [];

    for (let val of facet.values) {
      options.push({
        value: parseFloat(val.filter),
        label: getPriceLabel(parseFloat(val.filter), val.count),
        item: val,
      });
    }
    return options;
  };

  if (!isExpanded) {
    return null;
  }

  // Handle checkbox change
  const handleCheckboxChange = (value: number) => {
    onFilterChange(value);
  };

  return (
    <div className="px-2 py-3 space-y-2">
      {generateOptions().map((option) => (
        <div key={option.value} className="flex items-top">
          <input
            type="checkbox"
            id={`value-${option.value}`}
            checked={isFilterSelected(facet, option.item)}
            onChange={() => handleCheckboxChange(option.value)}
            className="mr-2 h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
          />
          <label
            htmlFor={`value-${option.value}`}
            className="text-sm text-gray-700 cursor-pointer"
          >
            {option.label}
            {suffix}
          </label>
        </div>
      ))}
    </div>
  );
};
